/* app/js/src/components/channel/platforms/custom/edit-codec-popup.component.scss */
:host {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10;
  display: none;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.cursor-pointer {
  cursor: pointer;
}
:host > div input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
:host > div input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
:host > div input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
:host > div input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
:host > div input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
:host > div input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
:host > div input.ng-invalid.ng-dirty,
:host > div input.ng-invalid.ng-touched {
  border-color: #ef5350;
}
:host > div .popup-footer .save-btn {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
:host > div .popup-footer .save-btn:focus {
  outline-color: #ffffff;
}
:host > div .popup-footer .save-btn:hover {
  background-color: white;
  color: #232f3a;
}
:host > div .popup-footer .disabled.save-btn {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
:host {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10;
  display: none;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.cursor-pointer {
  cursor: pointer;
}
:host > div input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
:host > div input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
:host > div input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
:host > div input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
:host > div input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
:host > div input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
:host > div input.ng-invalid.ng-dirty,
:host > div input.ng-invalid.ng-touched {
  border-color: #ef5350;
}
:host > div .popup-footer .save-btn {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
:host > div .popup-footer .save-btn:focus {
  outline-color: #ffffff;
}
:host > div .popup-footer .save-btn:hover {
  background-color: white;
  color: #232f3a;
}
:host > div .popup-footer .disabled.save-btn {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.codec-name[contenteditable=true]:focus {
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #e1e6eb;
  color: #232f3a;
  outline: none;
}
.codec-name[contenteditable=true]:focus ::-webkit-input-placeholder {
  color: #c9cdd6;
}
:host > div {
  position: relative;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  padding: 22px 35px;
  font-size: 12px;
}
:host > div .popup-footer {
  position: absolute;
  right: 35px;
  bottom: 9px;
}
:host > div .popup-footer .save-btn {
  font-size: 11px;
  width: 62px;
  height: 30px;
  padding: 9px 17px;
}
:host > div section {
  margin-bottom: 17px;
}
:host > div section header {
  font-size: 14px;
  margin-bottom: 25px;
  line-height: 14px;
}
:host > div section icn-dropdown {
  font-size: 12px;
  line-height: 30px;
}
:host > div .main-header {
  font-size: 24px;
  margin-bottom: 27px;
  line-height: 24px;
}
:host > div .x-sign {
  position: absolute;
  top: 13px;
  right: 13px;
  cursor: pointer;
}
:host > div input {
  padding: 0 0 0 15px;
}
:host > div input[type=number]::-webkit-outer-spin-button,
:host > div input::-webkit-inner-spin-button {
  position: relative;
  height: 20px;
  line-height: 30px;
}
:host > div .label {
  color: #879baf;
  display: inline-block;
  margin-right: 15px;
}
:host > div div {
  font-size: 12px;
  line-height: 12px;
}
:host {
  display: flex;
  animation-duration: 0.3s;
  animation-name: enter;
}
.codec-popup {
  width: 745px;
  height: 550px;
}
.codec-popup header {
  margin-bottom: 20px;
}
.codec-popup .label {
  margin-bottom: 8px;
}
.codec-popup input {
  width: 78px;
  height: 32px;
}
.codec-popup .codec-settings {
  display: inline-block;
  margin-right: 15px;
  font-size: 14px;
}
.codec-popup .codec-settings > div {
  display: block;
}
.codec-popup span {
  margin-left: 6px;
  font-size: 12px;
}
.codec-name {
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 27px;
  font-style: italic;
  display: inline-block;
}
.change-button {
  color: #c9cdd6;
  font-size: 14px;
  cursor: pointer;
  font-style: italic;
}
.resolution-field {
  width: 160px;
}
.profile-select-dropdown {
  width: 136px;
}
.colour-space-select-dropdown {
  width: 140px;
}
.colour-range {
  margin-left: 15px;
}
.colour-range .label {
  cursor: pointer;
}
.colour-range evrideo-checkbox {
  position: relative;
  bottom: -6px;
  margin-right: 5px;
}
.special-options input {
  width: 200px;
}
.field {
  display: inline-block;
}
/*# sourceMappingURL=edit-codec-popup.component.css.map */
